module.exports = __webpack_public_path__ + "img/XL.dd48bef6.png";